import React from 'react';
import { Card } from './ui/card';
import { Award, MapPin, Users, Home } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { getTranslation } from '../translations';

const iconMap = {
  Award: Award,
  MapPin: MapPin,
  Users: Users,
  Home: Home
};

const icons = [Award, MapPin, Users, Home];

const WhyOakham = ({ data }) => {
  const { language } = useLanguage();
  
  // Get translated data
  const translatedData = getTranslation(language, 'whyOakham');
  const title = translatedData?.title || data.title;
  const subtitle = translatedData?.subtitle || data.subtitle;
  const reasons = translatedData?.reasons || data.reasons;

  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-black text-gray-900 mb-4">
            {title}
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            {subtitle}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {reasons.map((reason, index) => {
            const Icon = icons[index] || Award;
            return (
              <Card 
                key={index}
                className="p-6 text-center hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 bg-gradient-to-br from-white to-gray-50"
              >
                <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <Icon className="h-8 w-8 text-green-600" />
                </div>
                <h3 className="text-xl font-black text-gray-900 mb-3">
                  {reason.title}
                </h3>
                <p className="text-sm text-gray-600 leading-relaxed">
                  {reason.description}
                </p>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyOakham;